export default __webpack_public_path__ + "static/lysicrates-watercolor-background-665b5607741a44f015195a6274cf1fa3.jpg";